import axios from 'axios';
import { useAuthStore } from '@/stores/auth';
import { useJournalPurchasesStore } from '@/stores/journalPurchases';
import { emitEvent } from '@/utils/eventBus';

const base = `${import.meta.env.VITE_STRAPI_URL ?? 'http://localhost:1337'}/api/supplier-invoices`;
const request = async (invoiceId, path = '', data) => {
  const auth = useAuthStore();
  const config = { headers: auth.token ? auth.requestHeaders.headers : {} };
  const url = `${base}/${encodeURIComponent(invoiceId)}/purchases${path}`;
  try {
    const response = data === undefined ? await axios.get(url, config) : await axios.post(url, data, config);
    return response.data.data;
  } catch (error) {
    throw new Error(error.response?.data?.error?.message || 'Could not update Purchases. Please try again.');
  }
};
export const listInvoicePurchases = (invoiceId) => request(invoiceId);
export const prepareInvoicePurchase = (invoiceId, index) => request(invoiceId, `/${index}/prepare`, {});
export const importInvoicePurchase = async (invoiceId, index, data) => {
  const result = await request(invoiceId, `/${index}/import`, data);
  if (result.purchase && !result.alreadyAdded) {
    useJournalPurchasesStore().initialized = false;
    emitEvent('purchases:changed', {
      dates: result.purchase.date ? [result.purchase.date] : [],
      buildingId: result.purchase.building?.id || null,
      buildingIds: result.purchase.building?.id ? [String(result.purchase.building.id)] : [],
      purchaseIds: [result.purchase.id, result.purchase.documentId].filter(Boolean).map(String),
    });
  }
  return result;
};
